import { ref, update } from "firebase/database";
import { storage, db } from "./firebase";
import { v4 as uuidv4 } from "uuid";
import { ref as storageRef, uploadBytes, getDownloadURL } from "firebase/storage";
import bcrypt from "bcryptjs";
import { setAuthorization } from "../Functions/AuthFunction";
import { verifyAuth } from "./authFunction";

const COMPANIES_PATH = "contacthq/companies";

export const getCompanyDetails = async () => {
  try {
    const response = await verifyAuth();
    if (!response.success) {
      return { success: false, error: "Unauthorized: Invalid Token." };
    }
    const { companyData } = response;
      const sendData = {
      companyId: companyData.companyId,
      companyName: companyData.companyName,
      businessType: companyData.businessType,
      companySize: companyData.companySize,
      country: companyData.country,
      name: companyData.name,
      email: companyData.email,
      mobile: companyData.mobile,
      profilePicURL: companyData.profilePicURL,
      role: companyData.role,
      token: companyData.token,
      websiteUrl: companyData.websiteUrl,
      subscription: companyData.subscription,
      paymentHistory: (() => {
        const root = Array.isArray(companyData.paymentHistory)
          ? companyData.paymentHistory
          : [];
        const nested = Array.isArray(companyData.subscription?.paymentHistory)
          ? companyData.subscription.paymentHistory
          : [];
        if (!nested.length) return root;
        if (!root.length) return nested;
        const byId = new Map();
        [...root, ...nested].forEach((tx) => {
          if (tx?.id) byId.set(tx.id, tx);
        });
        return Array.from(byId.values());
      })(),
      trialEndsAt:
        companyData.trialEndsAt || companyData.subscription?.expiresAt,
      status: companyData.status,
      createdAt: companyData.createdAt,
      lastLoginAt: companyData.lastLoginAt,
      lastPasswordChange: companyData.lastPasswordChange,
    };

    return { success: true, data: sendData };
  } catch (error) {
    console.error("Error fetching company details:", error);
    return { success: false, message: error.message || "Failed to get company details." };
  }
};


export const updateCompanyProfilePicture = async (file) => {
  if (!file) return { success: false, message: "No file uploaded. Please select a valid image file." };
  if (file.size > 2 * 1024 * 1024) return { success: false, message: "File size must be under 2MB." };
  try {
    const auth = await verifyAuth();
    if (!auth.success) return { success: false, error: auth.error };
    const { companyId } = auth.companyData;
    const picStorageRef = storageRef(storage, `${COMPANIES_PATH}/${companyId}/logo`);
    await uploadBytes(picStorageRef, file);
    const profilePicURL = await getDownloadURL(picStorageRef);
    await update(ref(db, `${COMPANIES_PATH}/${companyId}`), { profilePicURL });
    return {
      success: true,
      message: "Profile picture updated successfully.",
      profilePicURL,
    };
  } catch (error) {
    console.error("🔥 Profile picture update error:", error);
    return { success: false, message: error.message || "An error occurred while updating the profile picture." };
  }
};


export const changePassword = async (oldPassword, newPassword) => {
  try {
    const auth = await verifyAuth();
    if (!auth.success) return { success: false, error: "Unauthorized: Invalid Session." };
    const { companyId, password: currentHashedPassword } = auth.companyData;
    const isMatch = bcrypt.compareSync(oldPassword, currentHashedPassword);
    if (!isMatch) return { success: false, error: "Incorrect old password." };
    const hashedNewPassword = bcrypt.hashSync(newPassword, 10);
    const newToken = uuidv4();
    const timestamp = new Date().toISOString();
    const companyRef = ref(db, `${COMPANIES_PATH}/${companyId}`);
    await update(companyRef, {
      token: newToken,
      password: hashedNewPassword,
      lastPasswordChange: timestamp,
    });
    setAuthorization(newToken, companyId);
    return { success: true, message: "Password changed successfully." };
  } catch (error) {
    console.error("Change Password Error:", error);
    return { success: false, error: "An unexpected error occurred." };
  }
};